module.exports = __webpack_public_path__ + "media/assets/images/marker-agent-271061283a78ee5236ef107c726f288e.svg";